<app-auth-layout>
  <h1>Ingresa tu código</h1>
  <span>Ingresa el código  que se envió a tu correo para confirmarlo</span>
  <div class="code-inputs">
    <input #codeInput type="text" maxlength="1" pattern="[0-9]" (input)="onInput($event, 0)">
    <input #codeInput type="text" maxlength="1" pattern="[0-9]" (input)="onInput($event, 1)">
    <input #codeInput type="text" maxlength="1" pattern="[0-9]" (input)="onInput($event, 2)">
    <input #codeInput type="text" maxlength="1" pattern="[0-9]" (input)="onInput($event, 3)">
  </div>
  <span>Si no lo recibiste da click para <a >reenviar código</a> </span>
  <div class="container-buttons">
    <button type="button" >Cancelar</button>
    <button type="submit" >Siguiente</button>
  </div>
</app-auth-layout>
